/**
 * Order priority — v149.40.
 *
 * How urgently the brand wants an order handled. Set on the New order
 * cart or at its checkout, stored on each order row as `priority`, and
 * shown on the order in Orders. "Normal" is what every order already is,
 * so it's never badged — only High and Urgent stand out.
 *
 * The values match `ManualOrderPayload.priority` on the backend, which
 * refuses anything else.
 */
export const ORDER_PRIORITIES = [
  { id: "normal", label: "Normal" },
  { id: "high", label: "High" },
  { id: "urgent", label: "Urgent" },
];

export function PriorityPicker({ value = "normal", onChange, disabled = false, tone = "light", testIdPrefix }) {
  return (
    <div className="grid grid-cols-3 gap-2" role="radiogroup" aria-label="Priority" data-testid={testIdPrefix}>
      {ORDER_PRIORITIES.map(({ id, label }) => {
        const on = value === id;
        const cls = tone === "dark"
          ? (on ? "border-white bg-white text-ink" : "border-white/50 text-white")
          : (on ? "border-ink bg-ink text-white" : "border-ink bg-white");
        return (
          <button
            key={id}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(id)}
            disabled={disabled}
            data-testid={testIdPrefix ? `${testIdPrefix}-${id}` : undefined}
            className={`border-2 px-2 py-2 text-xs font-bold min-w-0 disabled:opacity-60 ${cls}`}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export function PriorityChip({ priority, testId }) {
  if (priority !== "high" && priority !== "urgent") return null;
  const cls = priority === "urgent" ? "bg-coral text-white" : "bg-sun";
  return (
    <span
      className={`inline-block border-2 border-ink px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${cls}`}
      data-testid={testId}
    >
      {priority === "urgent" ? "Urgent" : "High priority"}
    </span>
  );
}
